module.exports = __webpack_public_path__ + "static/media/ad.fac11979.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ad.png
// module id = 1052
// module chunks = 0